import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ExternalLink, AlertTriangle } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { Button } from '../components/ui/Button';
export function HelpShopifyPage() {
  return <div className="min-h-screen bg-gray-50" dir="rtl" data-id="element-1307">
      <Navbar data-id="element-1308" />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1309">
        <Link to="/configure" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6" data-id="element-1310">
          <ArrowRight className="ml-2 w-4 h-4" data-id="element-1311" />
          رجوع إلى الإعدادات
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-1312">
          <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-green-50 to-emerald-50" data-id="element-1313">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1314">
              كيفية ربط Shopify
            </h1>
            <p className="text-gray-600" data-id="element-1315">
              اتبع الخطوات التالية للحصول على Admin API Access Token من متجر
              Shopify
            </p>
          </div>

          <div className="p-8 space-y-8" data-id="element-1316">
            {/* Warning */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 flex items-start gap-3" data-id="element-1317">
              <AlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" data-id="element-1318" />
              <div className="text-sm text-yellow-800" data-id="element-1319">
                <strong data-id="element-1320">تحذير أمني:</strong> لا تشارك Admin API Access Token مع
                أي شخص. احتفظ به في مكان آمن.
              </div>
            </div>

            {/* Steps */}
            <div className="space-y-6" data-id="element-1321">
              <div className="flex gap-4" data-id="element-1322">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1323">
                  1
                </div>
                <div className="flex-1" data-id="element-1324">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1325">
                    افتح Shopify Admin
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1326">
                    سجل دخولك إلى لوحة تحكم Shopify الخاصة بمتجرك
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1327">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1328">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1329">
                  2
                </div>
                <div className="flex-1" data-id="element-1330">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1331">
                    اذهب إلى Apps and sales channels
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1332">
                    من القائمة الجانبية، اختر "Settings" → "Apps and sales
                    channels"
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1333">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1334">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1335">
                  3
                </div>
                <div className="flex-1" data-id="element-1336">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1337">
                    أنشئ Custom App
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1338">
                    اضغط على "Develop apps" → "Create an app" → أدخل اسم التطبيق
                    (مثلاً: Operiens Integration)
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1339">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1340">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1341">
                  4
                </div>
                <div className="flex-1" data-id="element-1342">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1343">
                    اضبط الصلاحيات (Scopes)
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1344">
                    اذهب إلى "Configure Admin API scopes" واختر الصلاحيات
                    المطلوبة:
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-1 mb-3" data-id="element-1345">
                    <li data-id="element-1346">read_products, write_products</li>
                    <li data-id="element-1347">read_orders, write_orders</li>
                    <li data-id="element-1348">read_customers, write_customers</li>
                  </ul>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1349">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1350">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1351">
                  5
                </div>
                <div className="flex-1" data-id="element-1352">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1353">
                    احصل على Admin API Access Token
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1354">
                    اضغط على "Install app" → انسخ "Admin API access token"
                    والصقه في صفحة الإعدادات
                  </p>
                  <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700 mb-3" data-id="element-1355">
                    ⚠️ هذا الـ Token سيظهر مرة واحدة فقط. احفظه في مكان آمن.
                  </div>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1356">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>
            </div>

            {/* Video Tutorial */}
            <div className="border-t border-gray-100 pt-8" data-id="element-1357">
              <h3 className="font-bold text-gray-900 mb-4" data-id="element-1358">شرح بالفيديو</h3>
              <div className="bg-gray-100 rounded-lg aspect-video flex items-center justify-center text-gray-500" data-id="element-1359">
                [فيديو يوتيوب - سيتم إضافته]
              </div>
            </div>

            {/* CTA */}
            <div className="border-t border-gray-100 pt-8" data-id="element-1360">
              <Link to="/configure" data-id="element-1361">
                <Button size="lg" fullWidth data-id="element-1362">
                  رجوع إلى الإعدادات
                  <ArrowRight className="mr-2 w-5 h-5" data-id="element-1363" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>;
}